import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Bestcabserviceinmumbai() {



const cardData = {
  keyword: " Best Cab Service in Mumbai",

headingDescription:
  "Omshree Cab is recognized as one of the best cab services in Mumbai, offering dependable, comfortable, and professional transportation solutions for all your travel needs. Whether you’re heading to the airport, commuting for work, planning local sightseeing, booking outstation trips, or arranging corporate travel, our service ensures a smooth, safe, and stress‑free journey with experienced drivers and well‑maintained vehicles. We provide flexible booking options including one‑way rides, round trips, hourly rentals, full‑day packages, and long‑distance travel plans with transparent pricing and no hidden charges. Our diverse fleet includes air‑conditioned sedans, spacious SUVs, luxury cars, multi‑purpose vehicles (MPVs), and tempo travelers suitable for solo travelers, families, groups, and corporate clients. With punctual pickups from any location in Mumbai, easy online booking, and 24/7 customer support, Omshree Cab stands out as a trusted choice for the best cab service in the city.",

topPlaces: [
  {
    title: "Gateway of India",
    description:
      "The Gateway of India is one of Mumbai’s most iconic and historic landmarks, located along the Arabian Sea in South Mumbai. Tourists and locals alike visit this grand arch monument for sightseeing, photography, and ferry rides to Elephanta Island. The surrounding Colaba area also offers vibrant street markets, cafes, and heritage buildings. Choosing the best cab service in Mumbai makes it easy to reach this famous destination comfortably, especially if you’re exploring South Mumbai’s attractions without dealing with heavy traffic or limited parking."
  },
  {
    title: "Marine Drive",
    description:
      "Marine Drive, known as the Queen’s Necklace because of its shimmering night lights, is a scenic coastal road along the Arabian Sea that offers breathtaking sunset views and refreshing sea breezes. Locals and tourists alike visit for evening walks, photo opportunities, and leisurely drives. A top cab service allows you to enjoy this elegant route with comfort, flexibility, and convenience, ideal for memorable city sightseeing experiences."
  },
  {
    title: "Juhu Beach",
    description:
      "Juhu Beach is one of Mumbai’s most popular seaside attractions known for its sandy shores, vibrant atmosphere, and street food delights like pav bhaji, pani puri, and bhel puri. The beach draws families, friends, and tourists throughout the year, especially at sunset. The best cab service ensures a comfortable ride to the beach from any part of the city without worrying about crowded public transport or parking difficulties."
  },
  {
    title: "Siddhivinayak Temple",
    description:
      "Siddhivinayak Temple is a highly revered Hindu temple dedicated to Lord Ganesha. Devotees and tourists visit the temple to seek blessings, take part in rituals, and admire the spiritual ambience and beautiful architecture. Festivals like Ganesh Chaturthi attract large crowds. The best cab service in Mumbai offers convenient transportation, helping you avoid traffic congestion and parking challenges near this busy spiritual landmark."
  },
  {
    title: "Bandra Worli Sea Link",
    description:
      "The Bandra Worli Sea Link is one of Mumbai’s most impressive engineering marvels, connecting Bandra and Worli across the Arabian Sea. This cable‑stayed bridge offers panoramic views of the sea and city skyline, making it a must‑see route for visitors and locals alike. A premium cab service ensures a smooth and scenic journey across this landmark, perfect for memorable rides and urban exploration."
  },
  {
    title: "Haji Ali Dargah",
    description:
      "Haji Ali Dargah is a renowned spiritual and cultural landmark located on a small island off the coast of Mumbai. The white marble structure rises beautifully from the Arabian Sea and is connected to the mainland by a narrow walkway that becomes visible during low tide. Devotees from diverse backgrounds visit for prayers, reflection, and serene sea views. The best cab service makes traveling to this unique spot easy and comfortable, even during peak hours."
  },
  {
    title: "Elephanta Caves",
    description:
      "Elephanta Caves are ancient rock‑cut temples located on Elephanta Island in Mumbai Harbour, known for their detailed stone carvings and historical significance. The UNESCO World Heritage Site attracts tourists interested in art, culture, and history. The best cab service in Mumbai ensures a timely and comfortable ride to the ferry terminal at Gateway of India, making your excursion to Elephanta Island hassle‑free."
  },
  {
    title: "Sanjay Gandhi National Park",
    description:
      "Sanjay Gandhi National Park is a large protected forest area within Mumbai that offers nature walks, wildlife spotting, trekking trails, and the ancient Kanheri Caves. Visitors come here to escape the city’s hustle and bustle and enjoy scenic greenery. Using the best cab service provides convenient access from anywhere in Mumbai and allows you to explore the park and its attractions without transportation stress."
  },
  {
    title: "Colaba Causeway",
    description:
      "Colaba Causeway is a bustling shopping street in South Mumbai filled with markets, stalls, cafes, and local eateries. It is a favorite destination for shopping enthusiasts and those looking to experience local culture. A premium cab service makes it easy to reach this lively market area and continue exploring other attractions in the city efficiently and comfortably."
  },
  {
    title: "Hanging Gardens",
    description:
      "Hanging Gardens, also known as Pherozeshah Mehta Gardens, are beautifully landscaped terraces on Malabar Hill offering panoramic views of Marine Drive and the Arabian Sea. The gardens are a peaceful retreat for visitors looking for relaxation, photography, and scenic views. The best cab service ensures a hassle‑free ride to this serene location and makes it simple to include in your Mumbai sightseeing itinerary."
  }
],



services: [
{
name: "Best Cab Service in Mumbai",
description: "Best cab service in Mumbai offers reliable and comfortable transportation across the city and nearby destinations. Professional drivers provide punctual pickup and safe driving services from homes, offices, hotels, railway stations, and airport terminals. Vehicles are well maintained and suitable for local travel, airport transfers, and outstation journeys. Ideal for business travelers, tourists, and families. Air-conditioned vehicles ensure comfortable journeys during city travel. Flexible booking options allow passengers to reserve rides easily anytime."
},
{
name: "Best Taxi Service Mumbai",
description: "Best taxi service in Mumbai provides dependable transportation with professional drivers and comfortable vehicles. Travelers can easily book taxis for city rides, airport transfers, and long-distance journeys. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business meetings, family trips, and tourism travel. Spacious vehicles ensure relaxed journeys across Mumbai. Reliable service ensures safe and timely transportation. Flexible booking options allow convenient ride scheduling."
},
{
name: "Top Cab Service Mumbai",
description: "Top cab service in Mumbai offers high-quality transportation services for travelers across the city. Vehicles are well maintained and suitable for local rides, airport transfers, and outstation travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travel, tourism visits, and daily commuting. Comfortable interiors ensure smooth journeys for passengers. Flexible booking options allow easy cab reservations."
},
{
name: "Reliable Taxi Service Mumbai",
description: "Reliable taxi service in Mumbai provides dependable transportation for passengers traveling across the city. Vehicles are maintained to ensure safety, comfort, and smooth travel experiences. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow passengers to reserve rides conveniently."
},
{
name: "Trusted Cab Service Mumbai",
description: "Trusted cab service in Mumbai offers secure and reliable transportation for travelers seeking safe journeys across the city. The service focuses on professional drivers, well-maintained vehicles, and punctual pickup services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for daily commuting, business travel, and tourism visits. Comfortable vehicles ensure smooth travel experiences. Reliable service ensures passenger satisfaction. Flexible booking options allow convenient ride reservations."
},
{
name: "Affordable Taxi Service Mumbai",
description: "Affordable taxi service in Mumbai provides economical transportation solutions for travelers seeking budget-friendly travel options. Vehicles offer comfortable seating and reliable city travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for students, tourists, and daily commuters. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow cost-effective travel planning."
},
{
name: "Premium Cab Service Mumbai",
description: "Premium cab service in Mumbai offers high-quality transportation for passengers seeking stylish and comfortable travel experiences. Premium vehicles provide spacious seating and smooth driving performance. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for corporate executives, business travel, and special occasions. Comfortable interiors ensure luxurious travel experiences. Flexible booking options allow convenient ride reservations."
},
{
name: "Best Airport Taxi Mumbai",
description: "Best airport taxi service in Mumbai provides reliable transportation to and from airport terminals across the city. Vehicles offer comfortable seating and luggage space suitable for passengers traveling with baggage. Professional drivers monitor flight schedules to ensure timely pickup and drop services. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travelers, tourists, and families. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow advance reservations."
},
{
name: "Best Outstation Cab Mumbai",
description: "Best outstation cab service in Mumbai offers comfortable transportation for travelers planning trips outside the city. Vehicles are suitable for long-distance highway travel and extended journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for weekend trips, pilgrimage tours, and family vacations. Spacious vehicles ensure comfortable journeys. Flexible booking options allow convenient travel planning."
},
{
name: "Best Car Rental Mumbai",
description: "Best car rental service in Mumbai provides convenient vehicle hire options for travelers exploring the city or planning long-distance journeys. Rental vehicles are well maintained and suitable for city rides and highway travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airports. Ideal for tourism travel, corporate trips, and family vacations. Comfortable vehicles ensure relaxed travel experiences. Flexible booking options allow easy reservations."
},
{
name: "Luxury Cab Service Mumbai",
description: "Luxury cab service in Mumbai provides premium transportation with stylish vehicles and comfortable interiors. Luxury vehicles offer spacious seating and smooth ride quality suitable for VIP travel and corporate journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for weddings, corporate executives, and special events. Premium interiors ensure relaxing travel experiences. Flexible booking options allow convenient luxury ride reservations."
},
{
name: "Professional Taxi Service Mumbai",
description: "Professional taxi service in Mumbai provides reliable transportation with experienced drivers and well-maintained vehicles. The service focuses on punctuality, safety, and comfortable travel experiences. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for business travel, tourism visits, and daily commuting. Comfortable vehicles ensure smooth journeys across the city. Professional drivers ensure consistent service quality. Flexible booking options allow convenient ride scheduling."
},
{
name: "Cheap Taxi Service Mumbai",
description: "Cheap taxi service in Mumbai offers economical transportation for travelers looking for budget-friendly travel options. Vehicles provide comfortable seating and reliable city travel at affordable prices. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for students, tourists, and daily commuters. Air-conditioned vehicles ensure comfortable journeys. Flexible booking options allow cost-effective ride reservations."
},
{
name: "Mumbai Top Cab Company",
description: "Mumbai top cab company provides professional transportation services across the city and nearby destinations. The company offers well-maintained vehicles and experienced drivers to ensure safe and comfortable journeys. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for business travel, tourism visits, and family trips. Spacious vehicles ensure smooth travel experiences across Mumbai. Reliable services ensure passenger satisfaction. Flexible booking options allow convenient ride reservations."
},
{
name: "Highly Rated Cab Service Mumbai",
description: "Highly rated cab service in Mumbai offers trusted transportation with excellent customer reviews and reliable travel experiences. Vehicles are well maintained and suitable for city rides, airport transfers, and long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourists, families, and corporate travelers. Comfortable vehicles ensure relaxed journeys. Flexible booking options allow easy ride reservations."
}
],

tableData: [
["Best Cab Service in Mumbai","Best Taxi Service Mumbai"],
["Top Cab Service Mumbai","Reliable Taxi Service Mumbai"],
["Trusted Cab Service Mumbai","Affordable Taxi Service Mumbai"],
["Premium Cab Service Mumbai","Best Airport Taxi Mumbai"],
["Best Outstation Cab Mumbai","Best Car Rental Mumbai"],
["Luxury Cab Service Mumbai","Professional Taxi Service Mumbai"],
["Cheap Taxi Service Mumbai","Mumbai Top Cab Company"],
["Highly Rated Cab Service Mumbai","Top Taxi Company Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Professional & Experienced Drivers",
    WhyChoosedescription: "Omshree Cabs provides highly experienced and professional drivers who are familiar with Mumbai’s busy roads, highways, and major routes. They ensure safe driving and timely arrivals whether you are traveling within the city or for outstation trips."
  },
  {
    WhyChooseheading: "Transparent & Affordable Pricing",
    WhyChoosedescription: "We offer clear and affordable pricing for cab services in Mumbai. Customers receive complete fare details including per-kilometer charges, tolls, and packages before booking so there are no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our cab service in Mumbai is available 24 hours a day. Whether you need a late-night airport pickup, early morning travel, or city rides during the day, Omshree Cabs is always ready to serve."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are regularly cleaned, sanitized, and well maintained. Fully air-conditioned cars ensure passengers enjoy a comfortable and relaxing ride."
  },
  {
    WhyChooseheading: "Local & Outstation Cab Services",
    WhyChoosedescription: "Customers can book cabs for local travel in Mumbai as well as outstation trips to popular destinations like Pune, Lonavala, Nashik, Shirdi, Surat, Mahabaleshwar, and Goa."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your journey begins smoothly and on time."
  },
  {
    WhyChooseheading: "Trusted Cab Service Provider",
    WhyChoosedescription: "Omshree Cabs is trusted by many customers for reliable taxi services in Mumbai. Our punctual drivers, comfortable vehicles, and professional service ensure a stress-free travel experience."
  }
]
};

const faqData = [
  { question: "Why is Omshree Cabs considered one of the best cab services in Mumbai?", answer: "Omshree Cabs is known for reliable drivers, clean vehicles, transparent pricing, and excellent customer support for local and outstation travel." },
  { question: "Is cab service available 24 hours in Mumbai?", answer: "Yes, Omshree Cabs provides 24/7 cab booking for airport transfers, local travel, and outstation journeys." },
  { question: "Which vehicles are available for booking?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on passenger requirements." },
  { question: "Do you provide airport pickup and drop services?", answer: "Yes, we provide reliable airport pickup and drop services for Mumbai International Airport." },
  { question: "Can I book a cab for outstation travel?", answer: "Yes, we provide outstation cab services from Mumbai to cities like Pune, Nashik, Shirdi, Surat, and many other destinations." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can I book a cab online?", answer: "Yes, customers can easily book cabs online or by phone for quick confirmation." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends, holidays, and peak travel seasons." },
  { question: "Do you provide corporate cab services?", answer: "Yes, we provide corporate transportation services for business travel, meetings, and employee transportation." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback:
      "Omshree Cabs truly provides one of the best cab services in Mumbai. The car was clean, the driver was punctual, and the ride was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Patil",
    feedback:
      "Great cab service in Mumbai. Easy booking, professional driver, and smooth travel experience. Highly recommended.",
    rating: 5
  }
];












































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service in Mumbai",
  "description": "Omshree Cab offers the best cab service in Mumbai, providing reliable, affordable, and professional taxi services. Enjoy premium and luxury cabs, airport transfers, outstation trips, and corporate travel with safe, comfortable, and punctual rides. Our trusted fleet and flexible booking options make every journey hassle-free.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Best Cab Service in Mumbai | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab provides the best cab service in Mumbai with reliable, affordable, and professional taxis. Premium and luxury cabs, airport transfers, outstation trips, and corporate travel with safe and comfortable rides." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
        <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinmumbai;